/* unplugin-vue-components disabled */import { render } from "./designated-driving.vue?vue&type=template&id=4d88b809"
import script from "./designated-driving.vue?vue&type=script&lang=js"
export * from "./designated-driving.vue?vue&type=script&lang=js"

import "./designated-driving.vue?vue&type=style&index=0&id=4d88b809&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__